<template>
  <div>
    <PageDynamicBreadcrumb />

    <PageHeader title="Keyword Exclusions Creator" />

    <q-form @submit="createKeywordExclusion">
      <q-card flat bordered>
        <q-card-section>
          <h5>Exclusion Details</h5>
        </q-card-section>
        <q-card-section>
          <div class="q-gutter-y-md">
            <q-select
              filled
              v-model="businessAccountId"
              :options="businessAccountOptions"
              label="Business Account"
              emit-value
              map-options
              disable="disable"
              hint="Currently restricted to Media.net Ads only."
            ></q-select>
            <q-select
              filled
              v-model="brandId"
              :options="brandOptions"
              label="Brand"
              emit-value
              map-options
              :rules="[val => (val && val.length > 0) || 'Select a Brand.']"
            ></q-select>
            <q-input
              v-model="keywordIds"
              filled
              type="textarea"
              label="Keyword IDs"
              hint="Enter a comma separated list of Keyword IDs to exclude."
              :rules="[
                val => (val && val.length > 0) || 'Enter Keyword IDs.',
                val =>
                  (val && /^(([0-9]+)(,(?=[0-9]))?)+$/.test(val)) ||
                  'Invalid Keyword IDs.'
              ]"
            />
          </div>
        </q-card-section>
      </q-card>
      <FormActionsSection>
        <template v-slot:primary-actions>
          <q-btn
            label="Create Exclusion"
            type="submit"
            color="primary"
            :disable="submitting"
            :loading="submitting"
          />
          <q-btn
            flat
            label="Cancel"
            to="/manage/keywords/exclusions"
            color="subtle"
            :disable="submitting"
          />
        </template>
      </FormActionsSection>
    </q-form>
  </div>
</template>

<script>
import axios from "axios";
import PageHeader from "@/components/UI/PageHeader";
import PageDynamicBreadcrumb from "@/components/UI/PageDynamicBreadcrumb";
import FormActionsSection from "@/components/UI/FormActionsSection";

export default {
  name: "KeywordExclusionCreator",
  components: {
    PageDynamicBreadcrumb,
    PageHeader,
    FormActionsSection
  },
  data() {
    return {
      businessAccountId: "",
      businessAccountOptions: [],
      brandOptions: [],
      keywordIds: [],
      brandId: [],
      submitting: false
    };
  },
  mounted() {
    this.$store.dispatch("brands/POPULATE_LIST").finally(() => {
      this.brandOptions = this.generateSelectOptionsArray(
        this.$store.state.brands.list,
        "name",
        "id"
      );
    });
    this.$store.dispatch("businesses/POPULATE_ACCOUNTS_LIST").finally(() => {
      this.businessAccountOptions = this.generateSelectOptionsArray(
        this.$store.state.businesses.accounts.list,
        "name",
        "id"
      );
      this.businessAccountId = "1009";
    });
  },
  methods: {
    createKeywordExclusion() {
      this.submitting = true;
      axios
        .post(
          "https://api-v2.jumpfeed.com/internal/keywords/exclusions/create",
          {
            brand_id: this.brandId,
            keyword_id: this.keywordIds,
            business_account_id: this.businessAccountId
          }
        )
        .then(() => {
          this.triggerActionOutcomeAlert("create", true);
          this.$router.push("/manage/keywords/exclusions");
        })
        .catch(err => {
          console.log(err);
          this.triggerActionOutcomeAlert("create", false);
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>

<style scoped lang="scss"></style>
